import { initBotId } from 'botid/client/core';
import { datadogRum } from '@datadog/browser-rum';
import {
  nextjsPlugin,
  onRouterTransitionStart
} from '@datadog/browser-rum-nextjs';
import { env, isDatadogEnabled, service, version } from '@/lib/datadog/config';
import { beforeSend } from '@/lib/datadog/beforeSend';

// Re-exporting this is required for Datadog RUM
export { onRouterTransitionStart };

// Protect browser-initiated mutation/auth routes.
initBotId({
  protect: [
    { path: '/api/shopify/addToCart', method: 'POST' },
    { path: '/api/shopify/updateCart', method: 'POST' },
    { path: '/api/shopify/removeFromCart', method: 'POST' },
    { path: '/api/shopify/createCart', method: 'POST' },
    { path: '/api/shopify/customer/account/*', method: 'POST' },
    { path: '/api/emailSubscription', method: 'POST' },
    { path: '/api/emailUnsubscribe', method: 'POST' },
    { path: '/api/celigoOptOutRequest', method: 'POST' }
  ]
});

// Off for local runs unless NEXT_PUBLIC_DATADOG_ENABLE_LOCAL is set. See config.
if (isDatadogEnabled) {
  datadogRum.init({
    applicationId: process.env.NEXT_PUBLIC_DATADOG_APPLICATION_ID,
    clientToken: process.env.NEXT_PUBLIC_DATADOG_CLIENT_TOKEN,
    site: process.env.NEXT_PUBLIC_DATADOG_SITE,
    service,
    env,
    version,

    // Normalizes view names /products/hybrid-mattress -> /products/[slug]
    plugins: [nextjsPlugin()],

    // Adds tracing headers to backend APM traces
    allowedTracingUrls: [
      {
        // Keep it same-origin
        match: (url) => url.startsWith(window.location.origin),

        // @vercel/otel uses the W3C headers so `tracecontext` matches that
        propagatorTypes: ['tracecontext']
      }
    ],

    sessionSampleRate: 100,
    sessionReplaySampleRate: 100,

    // Drops noisy, non-actionable errors and third-party resource events.
    // See lib/datadog/beforeSend.ts for the full filter list.
    beforeSend,

    // Email and password fields are auto-masked by DD, the rest are done using
    // `data-dd-privacy="mask-user-input"` on the input or parent el itself.
    defaultPrivacyLevel: 'allow'
  });
}
